module.exports = __webpack_public_path__ + "static/media/background-photo768.da83abbe.jpg";